import { useResidentContext } from "../../../features/residents/provider/ResidentProvider";
import { AssessmentReportFillTemplate } from "../../../features/reporting/templates/AssessmentReportFillTemplate";
import { FormEnums } from "../../../services/api/types/forms/enums/FormEnums";
import { useFormHistoryWithOffline } from "app/features/offline/hooks/useFormHistoryWithOffline";

const tag = FormEnums.RESIDENT_PORTFOLIO;
export function AddResidentDigitalPortfolio() {
  const { resident } = useResidentContext();

  const backPath = resident?.id
    ? `/residents/${resident.id}/portfolio`
    : undefined;

  const { data: entries, isLoading } = useFormHistoryWithOffline({
    tag,
    residentId: resident?.id,
  });

  const entry = entries?.[0];

  return (
    <AssessmentReportFillTemplate
      tag={tag}
      backPath={backPath}
      entriesAreVersioned
      entry={entry}
      isLoading={isLoading}
    />
  );
}
